<template>
  <div id="project-afkir-dini-hitori-detail">
    
    <div class="card card-custom gutter-b">
      <div class="card-header card-header-tabs-line">
        <ul
          class="nav nav-dark nav-bold nav-tabs nav-tabs-line"
          role="tablist"
          ref="builder-tab"
        >
          <router-link
            to="/project/afkir-dini/histori"
            v-slot="{ href, navigate, isActive, isExactActive }"
          >
          <li class="nav-item">
            <a
              class="nav-link"
              role="tab"
              :href="href" 
              @click="navigate"
              :class="[
                isActive && 'menu-item-active',
                isExactActive && 'menu-item-active'
              ]"
            >
              <span class="svg-icon svg-icon-md svg-icon-success m-0">
                <!--begin::Svg Icon-->
                <inline-svg src="media/svg/icons/Navigation/Left-2.svg"/>
                <!--end::Svg Icon-->
              </span>
              Kembali
            </a>
          </li>
          </router-link>
          <li class="nav-item">
            <a
              class="nav-link active"
              v-on:click="setActiveTab"
              data-tab="0"
              data-toggle="tab"
              role="tab"
            >
              View Data
            </a>
          </li>
        </ul>
      </div>

      <!--begin::View Data Farm-->
        <div class="card-body">
          <b-tabs class="hide-tabs" v-model="tabIndex">
            <b-tab active>
              <div class="mx-5" v-if="dataHistori != null">
                <!--begin::Top-->
                <div class="d-flex align-items-center">
                    <!--begin::Symbol-->
                    <div class="symbol symbol-65 symbol-light d-sm-inline d-none mr-5">
                        <span class="symbol-label">
                          <span class="svg-icon svg-icon-sm-3x svg-icon-primary">
                            <!--begin::Svg Icon-->
                            <inline-svg src="media/svg/icons/General/Clipboard.svg"/>
                            <!--end::Svg Icon-->
                          </span>
                        </span>
                    </div>
                    <!--end::Symbol-->

                    <!--begin::Info-->
                    <div class="d-flex flex-column flex-grow-1">
                        <a class="text-dark-75 text-hover-primary mb-1 font-size-h5 font-weight-bolder">
                          Farm {{ dataHistori.farm.nama }}
                        </a>
                        <div class="d-sm-flex d-block">
                            <div class="d-flex align-items-center mb-1 mr-sm-5">
                              <span class="svg-icon svg-icon-lg svg-icon-primary mr-1">
                                <!--begin::Svg Icon-->
                                <inline-svg src="media/svg/icons/Layout/Layout-arrange.svg"/>
                                <!--end::Svg Icon-->
                              </span>                       
                              <span class="text-muted font-weight-bold">{{ dataHistori.farm.sistemkandang.uraian }}</span>
                            </div>
                            <div class="d-flex align-items-center mb-1">
                              <span class="svg-icon svg-icon-lg svg-icon-primary mr-1">
                                <!--begin::Svg Icon-->
                                <inline-svg src="media/svg/icons/Home/Home.svg"/>
                                <!--end::Svg Icon-->
                              </span>                           
                              <span class="text-muted font-weight-bold">{{ dataHistori.farm.kepemilikan.uraian }} {{ dataHistori.farm.kepemilikan_name ? `(${dataHistori.farm.kepemilikan_name})` : '' }}</span>
                            </div>
                        </div>
                    </div>
                    <!--end::Info-->

                </div>
                <!--end::Top-->

                <!--begin::Bottom-->
                <div class="pt-3">
                    <!--begin::Text-->
                    <div class="d-flex align-items-center pt-5 mb-2">
                      <span class="svg-icon svg-icon-lg svg-icon-primary mr-2">
                        <!--begin::Svg Icon-->
                        <inline-svg src="media/svg/icons/Map/Marker1.svg"/>
                        <!--end::Svg Icon-->
                      </span>                           
                      <span class="text-dark-75 font-size-lg font-weight-normal">
                          Provinsi {{ dataHistori.farm.provinsi.uraian }}, 
                          {{ dataHistori.farm.kabupaten.uraian }}, 
                          Kecamatan {{ dataHistori.farm.kecamatan.uraian }}, 
                          Desa {{ dataHistori.farm.desa.uraian }}, 
                          {{ dataHistori.farm.alamat }}
                      </span>
                    </div>
                    <!--end::Text-->

                    <!--begin::Separator-->
                    <div class="separator separator-solid mt-6 mb-4"></div>
                    <!--end::Separator-->

                    <!--begin::Description-->
                    <div class="border rounded p-3 mb-5">
                      <div class="d-flex align-items-center mx-3">
                        <div class="symbol symbol-35 symbol-light mr-4">
													<span class="symbol-label">
                            <span class="svg-icon svg-icon-md svg-icon-primary">
                              <!--begin::Svg Icon-->
                              <inline-svg src="media/svg/icons/Communication/Group.svg"/>
                              <!--end::Svg Icon-->
                            </span> 
													</span>
												</div>         
                        <span class="text-dark-75 font-size-h5 font-weight-bolder">
                            Target
                        </span>
                      </div>
                      
                      <!--begin::Separator-->
                      <div class="separator separator-solid mt-3 mb-4"></div>
                      <!--end::Separator-->

                      <div class="d-flex align-items-center mx-sm-7 mx-2">
												<!--begin::Text-->
												<div class="d-flex flex-column flex-grow-1">
													<a class="m-1 text-success text-hover-primary font-size-lg font-weight-bolder">No. SE: {{ dataHistori.se.no_se }}</a>
                          <div class="m-1 d-sm-flex d-block">
                            <div class="d-flex align-items-center mr-6">
                              <span class="svg-icon svg-icon-lg svg-icon-primary mr-1">
                                <!--begin::Svg Icon-->
                                <inline-svg src="media/svg/icons/Home/Clock.svg"/>
                                <!--end::Svg Icon-->
                              </span>                       
                              <span class="text-muted font-weight-bold">{{ dataHistori.se_afkirdini.tgl_awal | dateIndonesia }} ~ {{ dataHistori.se_afkirdini.tgl_akhir | dateIndonesia }}</span>
                            </div>
                          </div>
                          <div class="m-1 d-flex align-items-center mr-6">
                            <span class="svg-icon svg-icon-lg svg-icon-primary mr-1">
                              <!--begin::Svg Icon-->
                              <inline-svg src="media/svg/icons/Shopping/Box3.svg"/>
                              <!--end::Svg Icon-->
                            </span>                       
                            <span class="text-muted font-weight-bold" v-for="(rinc, index) in dataHistori.se_afkirdini.child" :key="index">
                              {{ (index > 0 ? ', ':'') }} {{ rinc.sex }} <span class="text-primary font-weight-bolder">{{ rinc.jumlah | nominal }}</span> ekor
                            </span>
                          </div>
												</div>
												<!--end::Text-->
											</div>
                    </div>

                    <div class="border rounded p-3 mb-5">
                      <div class="d-flex align-items-center mx-3">
                        <div class="symbol symbol-35 symbol-light mr-4">
													<span class="symbol-label">
                            <span class="svg-icon svg-icon-md svg-icon-primary">
                              <!--begin::Svg Icon-->
                              <inline-svg src="media/svg/icons/General/Attachment2.svg"/>
                              <!--end::Svg Icon-->
                            </span> 
													</span>
												</div>         
                        <span class="text-dark-75 font-size-h5 font-weight-bolder">
                            Realisasi
                        </span>
                      </div>
                      
                      <!--begin::Separator-->
                      <div class="separator separator-solid mt-3 mb-4"></div>
                      <!--end::Separator-->

                      <div class="d-flex align-items-center mx-sm-7 mx-2">
												<!--begin::Text-->
												<div class="d-flex flex-column flex-grow-1">
													<a class="m-1 text-success text-hover-primary font-size-lg font-weight-bolder">No. BA: {{ dataHistori.no_ba }}</a>
                          <div class="m-1 d-sm-flex d-block">
                            <div class="d-flex align-items-center mr-6">
                              <span class="svg-icon svg-icon-lg svg-icon-primary mr-1">
                                <!--begin::Svg Icon-->
                                <inline-svg src="media/svg/icons/Home/Clock.svg"/>
                                <!--end::Svg Icon-->
                              </span>                       
                              <span class="text-muted font-weight-bold">{{ dataHistori.tgl_afkir | dateIndonesia }}</span>
                            </div>
                          </div>
                          <div class="m-1 d-flex align-items-center mr-6">
                            <span class="svg-icon svg-icon-lg svg-icon-primary mr-1">
                              <!--begin::Svg Icon-->
                              <inline-svg src="media/svg/icons/Shopping/Box3.svg"/>
                              <!--end::Svg Icon-->
                            </span>                       
                            <span class="text-muted font-weight-bold" v-for="(rinc, index) in dataHistori.rincian" :key="index">
                              {{ (index > 0 ? ', ':'') }} {{ rinc.sex }} <span class="text-primary font-weight-bolder">{{ rinc.jumlah | nominal }}</span> ekor
                            </span>
                          </div>
                          <div @click="downloadPdf(dataHistori.file)" class="m-1 d-flex align-items-center mr-6 cursor-pointer">
                            <span class="svg-icon svg-icon-lg svg-icon-primary mr-1">
                              <!--begin::Svg Icon-->
                              <inline-svg src="media/svg/icons/Files/DownloadedFile.svg"/>
                              <!--end::Svg Icon-->
                            </span>                       
                            <span class="text-primary font-weight-bolder">Download BA</span>
                          </div>
												</div>
												<!--end::Text-->
											</div>
                    </div>

                    <div class="border rounded p-3 mb-5">
                      <div class="d-flex align-items-center mx-3">
                        <div class="symbol symbol-35 symbol-light mr-4">
													<span class="symbol-label">
                            <span class="svg-icon svg-icon-md svg-icon-primary">
                              <!--begin::Svg Icon-->
                              <inline-svg src="media/svg/icons/Map/Marker1.svg"/>
                              <!--end::Svg Icon-->
                            </span> 
													</span>
												</div>         
                        <span class="text-dark-75 font-size-h5 font-weight-bolder">
                            Map Lokasi
                        </span>
                      </div>
                      
                      <!--begin::Separator-->
                      <div class="separator separator-solid mt-3 mb-4"></div>
                      <!--end::Separator-->

                      <div class="rounded iframe-content">
                        <div id="gmaps" ref="goomaps"></div>
                      </div>
                      
                    </div>                   

                    <!--end::Description-->
                </div>
                <!--end::Bottom-->
              </div>

              <div v-else>
                <FacebookLoader></FacebookLoader>
              </div>

            </b-tab>
          </b-tabs>
        </div>

    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Loader } from '@googlemaps/js-api-loader';
import { FacebookLoader } from 'vue-content-loader'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import AfkirDiniService from "@/core/services/api/data/afkirdini.service";
import ErrorService from "@/core/services/error.service";

export default {
  name: "project-afkir-dini-hitori-detail",
  props: {
    idBA: {
      required: true
    }
  },
  components: {
    FacebookLoader
  },
  data() {
    return {
      tabIndex: 0,
      dataHistori: null,
      gooMaps: null,
      gooMarker: null,
    }
  },
  computed:{
    ...mapGetters(["currentUser"]),
  },
  methods: {
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set clicked tab index to bootstrap tab
      this.tabIndex = parseInt(event.target.getAttribute("data-tab"));

      // set current active tab
      event.target.classList.add("active");

      // keep active tab
      localStorage.setItem("builderTab", this.tabIndex);
    },

    getData () {
      AfkirDiniService.getHistoriDetail({ _id: this.idBA })
        .then((res) => {
            if (!res.data.status) {
                ErrorService.message(res.data)
                return;
            }
            this.dataHistori = res.data.data
            this.dataHistori.farm = {...res.data.data.farm, geotag: JSON.parse(res.data.data.farm.geotag)}
            this.$nextTick(() => {
              setTimeout(() => {
                this.initMaps()              
              }, 500);
            })
        })
        .catch((err) => ErrorService.status(err))
    },
    initMaps() {
      const loader = new Loader({
          apiKey: process.env.VUE_APP_GOOGLE_MAP_API_KEY,
          version: "weekly",
          libraries: ["places"]
      });

      loader.load()
        .then((google) => {
          this.gooMaps = new google.maps.Map(this.$refs.goomaps, {
            center: this.dataHistori.farm.geotag,
            zoom: 17,
            maId: "f7a6bf3173b56abc",
            controlSize: 25,
            mapTypeId: "roadmap",
            mapTypeControlOptions: {
              mapTypeIds: [],
            },

          });
          this.gooMarker = new google.maps.Marker({ position: this.dataHistori.farm.geotag, map: this.gooMaps });
        })
        .catch(err => {
          ErrorService.message({
            action: 'Peringatan',
            message: 'Maps gagal dimuat',
          })
        })
    },    
    downloadPdf(file) {
      if (file) {
        window.open(`${process.env.VUE_APP_API_URL}/dokumen/afkir-dini/${file}`, "_blank"); 
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Histori Afkir Dini" }]);
    if (!this.currentUser.menu.afkir_dini) {
      return this.$router.push({ name: 'dashboard'}).catch(()=>{})
    }
    this.getData()
  },
};
</script>
<style lang="scss">
  #project-afkir-dini-hitori-detail {
    .iframe-content {
      height: 400px;
      overflow: auto;
      
      #gmaps {
        height: 100%;
      }
    }
  }

</style>
